import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {UserAutocompleteModule} from '../../../core/user-autocomplete/user-autocomplete.module';
import {ProposerSubmitModalComponent} from './proposer-submit-modal.component';

@NgModule({
  imports: [ProposerSubmitModalModule.IMPORTS, MatDatepickerModule],
  declarations: ProposerSubmitModalModule.DECLARATIONS,
  exports: ProposerSubmitModalModule.DECLARATIONS,
})
export class ProposerSubmitModalModule {
  public static readonly IMPORTS = [
    CommonModule,
    MatButtonModule,
    UserAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
  ];

  public static readonly DECLARATIONS = [ProposerSubmitModalComponent];
}
